<kui-toggle [checked]="values[field.id]" id="{{ field.id }}" size="md" (onChange)="toggle($event)"></kui-toggle>
@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}
